exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".paginationContainer{display:flex;justify-content:center}.divider{box-sizing:content-box;height:0;overflow:visible;border-color:#ccc}", ""]);

